import { connect } from 'react-redux'

import { selectProductsList } from '../../../modules/product'

const mapStateToProps = (state) => ({
  productsList: selectProductsList(state),
})

const mapDispatchToProps = () => ({})

const redux = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component)

export { redux }
